import type { TSanctionBreachRank } from "@bbj-types/sanction/enums";
import { useCallback } from "react";
import { axiosV2 } from "../candidates/axios";

export interface IPostSanctionDecisionEvent {
  typeEvenement: string;
  dateEvenement: string;
  commentaireEvenement?: string;
}

export interface IPostSanctionDecisionBeneficiary {
  _id: string;
  gender: string;
  firstName: string;
  lastName: string;
  birthDate?: string;
  cafNumber?: string;
  poleEmploiNumber?: string;
  secuNumber?: string;
}

export interface IPostSanctionDecisionDetails {
  rangManquement: TSanctionBreachRank;
  typeSanctionValide: string;
  natureManquement: string;
  dateManquement: string;
  montantValide: number;
  modaliteDecisionValidee: string;
  dureeValidee: number;
  justificationDecisionSanction?: string;
}

export interface IPostSanctionDecision {
  beneficiary: IPostSanctionDecisionBeneficiary;
  details: IPostSanctionDecisionDetails;
}

export const usePostSanctionDecision = () => {
  const [state, execute, cancel] = axiosV2<null, IPostSanctionDecision>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IPostSanctionDecision) =>
      execute({
        url: "/candidates/sanctions/decision",
        data,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
